const BASE_URL = 'https://jsonplaceholder.typicode.com'

export const allUsersApi = async () => {
  return await fetch(`${BASE_URL}/users`)
}

export const allPostsApi = async () => {
  return await fetch(`${BASE_URL}/posts`)
}